/* eslint-disable no-underscore-dangle */
import axios, { AxiosError } from 'axios';
import { getSession } from '../store/auth/authActions';
import { redirect } from 'react-router';

let store;

export const injectStore = (_store) => {
	store = _store;
};

export const apiErrorResponse = (error) => {
	if (error.response) {
		console.log(error.response.data);
		console.log(error.response.status);
		console.log(error.response.headers);
	} else if (error.request) {
		console.log(error.request);
	} else {
		console.log('Error', error.message);
	}
};
const instance = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_DOMAIN,// {process.env.BACKEND_DOMAIN},
	withCredentials: true,
	Accept: 'application/json'
});

instance.interceptors.request.use(
	(config) => {
		const accessToken = store.getState().auth.accessToken;
		if (accessToken) {
			config.headers = { 
				...config.headers,
				Authorization: `Bearer ${accessToken}`,
			};
		}
		
		return config;
	},
	(err) => Promise.reject(err)
);

let calledOnce = false;

instance.interceptors.response.use((response) => {
	return response;
}, async (error) => {
	const originalRequest = error.config;
	if (error.response !== null) {
		if (error.response.status === 401 && !originalRequest._retry) {
			if (!calledOnce) {
				calledOnce = true;
				let refreshResponse;
				try {
					refreshResponse = await store.dispatch(getSession())
				} catch (error) {
					if (error.response && error.response.data) {
						return Promise.reject(error.response.data);
					}
					return Promise.reject(error);
				} finally {
					if(refreshResponse.payload.profile == null){
						redirect("/login")
						return Promise.reject(new AxiosError("Unauthorized"))
					}
					calledOnce = false;
					originalRequest._retry = true;
					return instance(originalRequest);
				}
			}
		}
	}

	return Promise.reject(error);
});

export default instance;
